
export const DOCS_FIELD_MAP_SHOW = {
    'payroll': 'Nómina',
    'contract': 'Contrato',
    'model_tax':'Modelos/Impuestos',
    'certificate':'Certificado',
    'bill':'Factura',
    'other': 'Otros',
    'pending': 'Pendiente',
    'waiting_approval': 'Pendiente de aprobación',
    'approved': 'Aprobado',
    'rejected': 'Rechazado',
    'insufficient_credits': 'Saldo insuficiente',
    'lost_workflow': 'Error workflow desaparecido', 
    'error': 'Error',
    'done': 'Completado',
    'WaitForApproval': 'Esperar aprobación',
    'AskAI': 'Extracción de informacion con IA',
    'AddDocumentRepresentationToConversation': 'Añadir representación de documento a conversación',
    'CompleteConversation': 'Completar conversación con IA',
    'UploadAsInvoice': 'Subir como factura',
    'SendThroughEmail': 'Enviar por correo electrónico',
    'SendEmailWithTemplate': 'Enviar correo electrónico con plantilla',
    'LookupAndMatchInstance': 'Buscar y adjuntar registro',
    'LookupAndMatchMultipleInstances': 'Buscar y adjuntar varios registros',
    'ExtractInstanceFromRawData': 'Extraer registro previamente inyectado',
    'CreateInstanceFromContext': 'Crear registro a partir de contexto',
    'CreateInstance': 'Crear registro',
    'CreateInstancesFromList': 'Crear registros a partir de lista',
    'AddInstanceToList': 'Añadir registro a lista',
    'ModifyContext': 'Modificar registro',
    'PayrollAccounting': 'Contabilizar nómina',
    'SendDataToEndpoint': 'Enviar datos a un endpoint',
    'NotifyCounterpart': 'Notificar a la contraparte',
    'RunCommand': 'Ejecutar comando',
    "RunQuery": "Ejecutar consulta",
    'RunScript': 'Ejecutar script de python',
};

export function updateFrontendData(frontend, data, count) {
    frontend.other_documents = data
    // frontend.other_documents = frontend.other_documents.slice(frontend.offset, frontend.offset + frontend.limit)
    frontend.selectedItems = []
    frontend.totalItems = count
    if(frontend.totalItems > 0){
        frontend.showSelect = true
    }
    frontend.selectAllItems = false;
    frontend.calculateTableHeight();
    frontend.drawer = false;
}

export function obtainFilters(frontend) {
    frontend.filters=[]
    frontend.filters.push({company_id: frontend.companydb_id});
    if(frontend.filter_doc_name)
        frontend.filters.push({original_file_name: frontend.filter_doc_name});
    if(frontend.filter_doc_type)
        frontend.filters.push({type: frontend.filter_doc_type});
    if(frontend.filter_date_from)
        frontend.filters.push({date_from: frontend.filter_date_from});
    if(frontend.filter_date_to)
        frontend.filters.push({date_to: frontend.filter_date_to});
    if(frontend.sortBy && frontend.sortBy != '')
        frontend.filters.push({order_by: frontend.sortBy})
    if(frontend.filter_need_approval)
        frontend.filters.push({need_approval: frontend.filter_need_approval})
}